import apiClient from './apiClient';
import { UseCaseDetail, UseCaseSummary, UseCaseCreate, UseCaseUpdate } from '../types';
import type { FolderListingResponse } from './documentService';

const apiBaseURL = '/use-cases/';

export const useCaseService = {
  async list(params: { skip?: number; limit?: number; cadrage_id?: string; available_for_cadrage?: boolean; domain_id?: string; audit_id?: string } = {}): Promise<UseCaseSummary[]> {
    const response = await apiClient.get(apiBaseURL, { params });
    return response.data;
  },

  async get(id: string): Promise<UseCaseDetail> {
    const response = await apiClient.get(`${apiBaseURL}${id}`);
    return response.data;
  },

  async create(payload: UseCaseCreate): Promise<UseCaseDetail> {
    const response = await apiClient.post(apiBaseURL, payload);
    return response.data;
  },

  async update(id: string, payload: UseCaseUpdate): Promise<UseCaseDetail> {
    const response = await apiClient.put(`${apiBaseURL}${id}`, payload);
    return response.data;
  },

  async moveDomain(id: string, domainId: string): Promise<UseCaseDetail> {
    const response = await apiClient.put(`${apiBaseURL}${id}/move-domain/`, {
      domain_id: domainId,
    });
    return response.data;
  },

  async remove(id: string): Promise<UseCaseDetail> {
    const response = await apiClient.delete(`${apiBaseURL}${id}`);
    return response.data;
  },

  async listPersonas(id: string): Promise<any[]> {
    const response = await apiClient.get<any[]>(`${apiBaseURL}${id}/personas/`);
    return response.data;
  },

  async updatePersonas(id: string, payload: any): Promise<void> {
    await apiClient.put(`${apiBaseURL}${id}/personas/`, payload);
  },

  async getReactFlow(id: string): Promise<any> {
    const response = await apiClient.get(`${apiBaseURL}${id}/react-flow/`);
    return response.data;
  },

  async saveReactFlow(id: string, payload: any): Promise<any> {
    const response = await apiClient.put(`${apiBaseURL}${id}/react-flow/`, payload);
    return response.data;
  },

  /** List MinIO folders and files within a use case's document space. */
  async listFolders(id: string, prefix?: string): Promise<FolderListingResponse> {
    const params = prefix ? { prefix } : undefined;
    const response = await apiClient.get<FolderListingResponse>(`${apiBaseURL}${id}/folders/`, { params });
    return response.data;
  },

  /** Create a folder within a use case's document space. */
  async createFolder(id: string, folderPath: string): Promise<void> {
    await apiClient.post(`${apiBaseURL}${id}/folders/`, { folder_path: folderPath });
  },

  /** Delete a folder (and its contents) within a use case's document space. */
  async deleteFolder(id: string, folderPath: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${id}/folders/`, {
      data: { folder_path: folderPath },
    });
  },
};

export default useCaseService;


